<template>
  <div class="products">
    <va-card :title="$t('products.cards.title')">
      <va-list fit>
        <vue-nestable
          v-model="products"
          :maxDepth='1'
          keyProp='order'
        >
          <template
            slot-scope="{ item, index }"
          >
            <va-item>
              <va-item-section>
                <vue-nestable-handle
                  :item="item"
                >
                  <va-item-label>
                    {{ item.id }} - {{ item.name }}
                  </va-item-label>
                </vue-nestable-handle>
              </va-item-section>
              <va-item-section side>
                {{index + 1}}
              </va-item-section>
            </va-item>
            <va-list-separator v-if="index < products.length - 1"/>
          </template>
        </vue-nestable>
      </va-list>
      <va-button
        @click='salvar'
      >
        Salvar
      </va-button>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { VueNestable, VueNestableHandle } from 'vue-nestable'
import 'vue-nestable/example/assets/vue-nestable.css'

export default {
  name: 'products',
  components: {
    VueNestable,
    VueNestableHandle,
  },
  methods: {
    salvar () {
      const self = this
      const vars = []
      let mutations = ''
      const values = {}
      this.products.forEach((element, i) => {
        const i1 = i + 1
        vars.push(`$order${i1}: Int, $id${i1}: Int!`)
        mutations += `
        up${i1}: update_product_by_pk(pk_columns: {id: $id${i1}}, _set: {order: $order${i1}}) {
          id
        }
        `
        values[`id${i1}`] = element.id
        values[`order${i1}`] = i1
      })
      this.$apollo
        .mutate({
          mutation:
            gql`
              mutation MyMutation(${vars.join(',')}) {
                ${mutations}
              }
              `,
          variables: values,
        })
        .then(_ => {
          self.showToast(
            self.$t(
              'toasts.successUpdate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
          this.$apollo.queries.products.refetch()
        })
        .catch(_ => {
          self.showToast(
            self.$t(
              'toasts.errorUpdate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      products: [],
    }
  },
  apollo: {
    products: {
      query: gql`
      query MyQuery {
        products: product(order_by: {order: asc}) {
          id
          name
          order
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          data.products.forEach((element, i) => {
            element.order = i
          })
        }
      },
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('products')) {
      this.$apollo.queries.products.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
